import React from "react";
import { CardLayout } from "components/cardLayout";
import "./MovingfulExperienceCard.scss"
import { getCustomerDetails } from 'core/services/getCustomerDetailsService'

export interface MovingfulExperienceCardProps {

}

export interface MovingfulExperienceCardState {
  Customer: any;

}

class MovingfulExperienceCard extends React.Component<MovingfulExperienceCardProps, MovingfulExperienceCardState> {
  private _isMounted: boolean = false;
  constructor(props: MovingfulExperienceCardProps) {
    super(props);
    this.state = {
      Customer: JSON.parse(localStorage.getItem("customerDetails") || '{}')
    };
  }
  async fetchData() {
    const params = new URLSearchParams(window.location.search);
    const phone = params.get('phone') || "8442070741"; //
    var CID = params.get('customerid');
    var securetoken = params.get('customerToken');
    if (!CID) {
      CID = localStorage.getItem("CID")
    }
    if (!securetoken) {
      securetoken = localStorage.getItem("securetoken")
    }
    //  const securetoken = params.get('customerToken'||"2e780fee-5aef-44fe-90b6-02e276e532aa");
    let response = await getCustomerDetails(CID || "", securetoken || "")


    console.log(response)
    localStorage.setItem("customerDetails", JSON.stringify(response[0]));
    this.setState({ Customer: response[0] })
    localStorage.setItem("EstimatorVideo", response[0].estimatorVideo);
  }

  componentDidMount() {
    this._isMounted = true;
    this.fetchData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    console.log(this.state.Customer.customerName)
    //  var cname = this.state.Customer.split(" ",0)
    //  console.log(cname)
    return (
      <div className="estimator-intro">
        <p>Hi {this.state.Customer.customerName}, It's {this.state.Customer.estimatorName}. Thanks for welcoming me into your home! Call with any questions about your estimate! I look forward to your move.</p>

      </div>
    );
  }
}

export default MovingfulExperienceCard;